import { useURLSearchParam } from './use_url_search_param';

const deserialize = (value: string | undefined): number | undefined => {
  if (value === undefined) return undefined;
  const num = Number(value);
  return isNaN(num) ? undefined : num;
};

const serialize = (value: number | undefined): string | undefined => {
  return value !== undefined ? String(value) : undefined;
};

export const useNumericURLSearchParam = (name: string, fallback: number | undefined = undefined) => {
  const [value, onChange] = useURLSearchParam(name);

  return [
    deserialize(value) ?? fallback,
    (value: number | undefined) => {
      onChange(value === fallback ? undefined : serialize(value));
    },
  ] as const;
};
